class BlackFridayBundle {
  constructor() {
    this.consultationVariantId = '54808756748674';
    this.methylationVariantId = '42096905617491';
    this.discountCode = 'AK7G7BHE3TTA';
    // Get the setting from the theme
    this.isEnabled = window.theme?.settings?.show_black_friday_deal || false;
    this.init();
  }

  init() {
    if (this.isEnabled) {
      this.attachEventListeners();
    }
  }

  attachEventListeners() {
    document.addEventListener('product:added-to-cart', this.handleProductAdded.bind(this));
  }

  async handleProductAdded(event) {
    const addedVariantId = event.detail.variantId;
    
    if (addedVariantId === this.methylationVariantId && this.isEnabled) {
      await this.addConsultation();
    }
  }

  async addConsultation() {
    try {
      // First add the consultation
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: this.consultationVariantId,
            quantity: 1,
            properties: {
              '_black_friday_free': true
            }
          }]
        })
      });

      // Check if any discount codes are already applied
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Check localStorage for previously applied discount
      const appliedDiscount = localStorage.getItem('blackFridayDiscountApplied');
      
      if ((!cart.cart_level_discount_applications || cart.cart_level_discount_applications.length === 0) && !appliedDiscount) {
        // Only apply discount if no codes are currently applied and hasn't been applied before
        await fetch('/discount/' + this.discountCode, {
          method: 'GET',
          credentials: 'same-origin' 
        });
        
        // Store that discount was applied
        localStorage.setItem('blackFridayDiscountApplied', 'true');
      }

      // Redirect to cart
      window.location.href = '/cart';
      
    } catch (error) {
      console.error('Error in Black Friday flow:', error);
    }
  }
}

// Initialize the bundle handler
new BlackFridayBundle();
